"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Branding API definition
 * Service to fetch MSO Branding Information.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team-cumulus@xperi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageType = void 0;
/**
 * Image types associated with an asset.
 * @export
 * @enum {string}
 */
exports.ImageType = {
    PrimaryBrandingLogo: 'primaryBrandingLogo'
};
